import { render, staticRenderFns } from "./trade-add-two.page.vue?vue&type=template&id=6fd89751&"
import script from "./trade-add-two.page.vue?vue&type=script&lang=js&"
export * from "./trade-add-two.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd89751')) {
      api.createRecord('6fd89751', component.options)
    } else {
      api.reload('6fd89751', component.options)
    }
    module.hot.accept("./trade-add-two.page.vue?vue&type=template&id=6fd89751&", function () {
      api.rerender('6fd89751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/tabTrade/trade-add-two.page.vue"
export default component.exports